import { CampaignType, SegmentTarget } from '../../../api/interfaces'
import ModernAudienceTargeter from '../../targeters/ModernAudienceTargeter'

type SegmentsFormProps = {
  campaignType: CampaignType
  segments: SegmentTarget[]
  onSegmentsChange: (segments: SegmentTarget[]) => void
}

export const SegmentsForm = ({ campaignType, segments, onSegmentsChange }: SegmentsFormProps) => {
  return (
    <ModernAudienceTargeter
      segments={segments}
      title={''}
      campaignType={campaignType}
      onSegmentClicked={(segment: SegmentTarget) => {
        onSegmentsChange([...segments, segment])
      }}
      onAudienceRemoved={segment => {
        onSegmentsChange(segments.filter(s => s.id !== segment.id))
      }}
    />
  )
}
